/**
 * <df-card-swipe>
 *
 * Wraps a product card's media link. On touch (coarse-pointer) devices the
 * primary and secondary product images are laid out as a horizontal
 * scroll-snap slider (see custom.css.liquid). This element keeps the dot
 * indicator in sync with the currently visible image.
 *
 * Desktop is untouched: there the secondary image stays a hover overlay and
 * this element does nothing.
 */
class DfCardSwipe extends HTMLElement {
  connectedCallback() {
    // Single-image cards have nothing to swipe through.
    if (this.hasAttribute('data-single')) return;

    this.scroller = this.querySelector('.product-card__media');
    this.dots = Array.from(this.querySelectorAll('.df-card-dot'));

    if (!this.scroller || this.dots.length < 2) return;

    // The slider only exists on coarse-pointer devices.
    this.pointerQuery = window.matchMedia('(pointer: coarse)');
    if (!this.pointerQuery.matches) return;

    this.activeIndex = 0;
    this.onScroll = this.onScroll.bind(this);
    this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    if (this.scroller) this.scroller.removeEventListener('scroll', this.onScroll);
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  onScroll() {
    // Throttle to one update per frame.
    if (this.rafId) return;

    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;

      const width = this.scroller.clientWidth;
      if (!width) return;

      const index = Math.round(this.scroller.scrollLeft / width);
      const clamped = Math.max(0, Math.min(index, this.dots.length - 1));

      if (clamped === this.activeIndex) return;

      this.dots[this.activeIndex].classList.remove('is-active');
      this.dots[clamped].classList.add('is-active');
      this.activeIndex = clamped;
    });
  }
}

if (!window.customElements.get('df-card-swipe')) {
  window.customElements.define('df-card-swipe', DfCardSwipe);
}
